import React, { cloneElement, Children, isValidElement } from "react"
import classnames from "classnames"

import styles from "./index.less"

export default (props) => {
  let { className, children } = props

  let footerClass = classnames(styles.footer, className)
  let footerItemClass = styles.item

  let items = Children.toArray(children)
  if (items.map) {
    items = items.filter(isValidElement).map((item, key) =>
      cloneElement(item, {
        key: key,
        className: classnames(footerItemClass, item.props.className),
      }),
    )
  }

  return <footer className={footerClass}>{items}</footer>
}
